import classNames from 'classnames';

interface SkeletonProps {
  className?: string;
}

const SkeletonLine = ({ className }: SkeletonProps) => (
  <div
    className={classNames(
      'h-4 rounded-md bg-grey-900 animate-pulse',
      className
    )}
  />
);

interface SkeletonTableProps {
  rows?: number;
  columns?: number;
}

export const SkeletonTable = ({ rows = 5, columns = 4 }: SkeletonTableProps) => {
  return (
    <div className="w-full animate-pulse" role="status" aria-label="Loading table data">
      {/* Header row */}
      <div className="flex gap-4 pb-3 border-b border-grey-800">
        {Array.from({ length: columns }).map((_, i) => (
          <SkeletonLine key={`h-${i}`} className="h-3 flex-1 bg-grey-800" />
        ))}
      </div>
      {/* Data rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div
          key={`r-${rowIdx}`}
          className="flex gap-4 py-4 border-b border-grey-900"
        >
          {Array.from({ length: columns }).map((_, colIdx) => (
            <SkeletonLine
              key={`r-${rowIdx}-c-${colIdx}`}
              className={classNames('flex-1', {
                'max-w-[60%]': colIdx === columns - 1,
                'max-w-[80%]': colIdx === 0,
              })}
              /* Stagger animation delay per row */
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export const Skeleton = SkeletonLine;
